import { inject, Injectable, isDevMode } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly STORAGE_KEY = 'app-language';
  private readonly DEFAULT_LANGUAGE = 'fr';

  private translate = inject(TranslateService);
  private currentLanguageSubject: BehaviorSubject<string>;
  public currentLanguage$: Observable<string>;

  constructor() {
    const savedLang = localStorage.getItem(this.STORAGE_KEY) || this.DEFAULT_LANGUAGE;
    this.currentLanguageSubject = new BehaviorSubject<string>(savedLang);
    this.currentLanguage$ = this.currentLanguageSubject.asObservable();
    // Fallback language is configured via TranslateModule.forRoot({ fallbackLang })
    // in app.config.ts. We only need to activate the saved/current language here.
    this.translate.use(savedLang);
  }

  setLanguage(langCode: string): void {
    const normalized = langCode.toLowerCase().split('-')[0];
    if (!['fr', 'en'].includes(normalized)) {
      if (isDevMode()) console.warn(`Language '${langCode}' not supported`);
      return;
    }
    this.translate.use(normalized);
    localStorage.setItem(this.STORAGE_KEY, normalized);
    this.currentLanguageSubject.next(normalized);
  }

  getCurrentLanguage(): string {
    return this.currentLanguageSubject.value;
  }
}
